import {
    GridExpandMoreIcon,
} from "@mui/x-data-grid";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Stack,
    Box,
} from "@mui/material";

export default function BaseFilterTableWithAccordion({ isExpanded, setExpanded, setTableVisibility, child, summary, actions }: any) {

    const handleFilterAccordionChange = (_: any, expanded: any) => {
        setExpanded(expanded);
        setTableVisibility(!expanded);
    }

    return (
        <Accordion sx={{ backgroundColor: 'none', boxShadow: 'rgba(99, 99, 99, 0.1) 0px 2px 8px 0px', border: 0, }} onChange={handleFilterAccordionChange} expanded={isExpanded}>
            <AccordionSummary
                expandIcon={<GridExpandMoreIcon />}
                aria-aria-controls="panel-filter-content">
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                    <h4 style={{ margin: 5 }}>{summary ?? '#'}</h4>
                    {actions && <Box onClick={(e) => e.stopPropagation()}>{actions}</Box>}
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                {<>{child}</>}
            </AccordionDetails>
        </Accordion>
    )
}